import { observer } from "mobx-react-lite";

import { usePageStore } from "../create-application-page.lib";
import { CreateApplicationApplicantStep } from "./create-application-applicant-tab/create-application-applicant-step";
import { CreateApplicationDocumentsStep } from "./create-application-documents-tab/create-application-documents-step";
import { CreateApplicationObjectDataStep } from "./create-application-object-data-tab/create-application-object-data-step";
import { CreateApplicationTypeStep } from "./create-application-type-tab/create-application-type-step";

export const CreateApplicationStepContent = observer(() => {
  const pageStore = usePageStore();
  const activeStep = pageStore?.activeStep ?? "type";

  if (activeStep === "type") {
    return (
      <CreateApplicationTypeStep
        selectedCategory={pageStore?.selectedCategory ?? null}
        onSelectCategory={(category) => pageStore?.setSelectedCategory(category)}
      />
    );
  }

  if (activeStep === "applicant") {
    return <CreateApplicationApplicantStep />;
  }

  if (activeStep === "object-data") {
    return <CreateApplicationObjectDataStep />;
  }

  if (activeStep === "documents") {
    return <CreateApplicationDocumentsStep />;
  }

  return null;
});
